import React from 'react';
import { UiToast } from '../ui-kit/UiToast';

export function UiToastAdapter(message, type = 'info') {
  // eslint-disable-next-line react/prop-types
  return ({ closeToast }) => (
    <UiToast message={message} type={type} closeToast={closeToast} />
  );
}
